import axios from './axios_api';
import * as url from './api.constant';

export const arpAssetAlter = async payload => {
  return await axios.post(url.ARP_ASSET_ALTER, payload);
};
